<template>
  <section class="space-y-3">
    <h2 class="text-base font-medium dark:text-gray-100">
      {{ t("pages.fitrana.info.title") }}
    </h2>

    <p
      v-for="(line, index) in tm('pages.fitrana.info.body')"
      :key="index"
      class="text-base text-gray-600 dark:text-gray-300 leading-relaxed"
    >
      {{ line }}
    </p>
  </section>
</template>

<script setup lang="ts">
const { t, tm } = useI18n();
</script>
